import EN from 'assets/lang/locales/en_US';
import { AxiosError, AxiosResponse } from 'axios';
import AppConfig from 'constants/AppConfig';
import { NotificationManager } from 'react-notifications';
import { LocalStorageKeys } from 'utils/constants';

export const onSuccessResponse = function (response: AxiosResponse): any {
  return response.data;
};

export const onFailedResponse = function (error: AxiosError): Promise<any> {
  if (error.response) {
    // [1] - Access denied
    if (error.response.status === 403) {
      window.location.href = '/access-denied';
    }

    // [2] - Unauthorized
    if (error.response.status === 401) {
      localStorage.removeItem(LocalStorageKeys.cms_user);
      localStorage.removeItem(LocalStorageKeys.access_token);
      localStorage.removeItem(LocalStorageKeys.expiredTime);
      window.location.href = '/';
    }

    // [3] - Expired session
    if ((error.response.data as any).code === 107) {
      window.location.href = '/expired-session';
    }
  }

  // global handle and show error messages.
  let message = 'global.errors.';

  if (error.response?.data && (error.response.data as any).message && (error.response.data as any).message !== '') {
    message += (error.response.data as any).code;
  } else if (error.response?.data && !(error.response.data as any).errors) {
    message += 'default';
  }

  if (EN[message] && EN[message] !== '') {
    NotificationManager.error(EN[message], '', AppConfig.notificationTimeout);
  }

  return Promise.reject(error.response?.data);
};
